import { DEFAULT_SHEET_NAME } from "../constants";
import type { TemplatesValue } from "../types";
import {
  CertificateOfInspectionId,
  Exit,
  GateAway,
  GrantPeriod,
  GrantedArea,
  LicensePlate,
  Team,
  VehicleName,
  VehicleRegistrationCertificateId,
} from "./_fields";

type ExternalBusinessVehicleCardLongTermProvideTemplate = {
  unit: string;
  nameVehical: string;
  licensePlate: string;
  vehicleRegistrationCertificateId: number;
  certificateOfInspectionId: number;
  grantPeriod: string;
  grantedArea: string;
  gateAway: string;
  exit: string;
};

export const externalBusinessVehicleCardLongTermProvideTemplate: TemplatesValue<ExternalBusinessVehicleCardLongTermProvideTemplate> =
  {
    fileName: "DanhSachThongTinPhuongTienDaiHanCapMoi",
    sheet: DEFAULT_SHEET_NAME,
    structures: [
      {
        ...Team,
        header: "Đơn vị",
      },
      VehicleName,
      LicensePlate,
      VehicleRegistrationCertificateId,
      CertificateOfInspectionId,
      GrantPeriod,
      GrantedArea,
      GateAway,
      Exit,
    ],
    fields: [
      "unit",
      "nameVehical",
      "licensePlate",
      "vehicleRegistrationCertificateId",
      "certificateOfInspectionId",
      "grantPeriod",
      "grantedArea",
      "gateAway",
      "exit",
    ],
  };
